export default __webpack_public_path__ + "static/media/06_nebezpeci-urazu.3e9ca6a3.jpg";